export default __webpack_public_path__ + "static/media/window2.03386e4b.png";